import {
  AbsoluteCenter,
  Box,
  Card, CardBody,
  CardHeader, CircularProgress, Code,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Image,
  Input,
  Stack,
  Text,
  useToast,
} from '@chakra-ui/react';
import React, {useEffect, useState} from 'react';
import {useVuplex} from '../../hooks/useVuplex';
import PageTitle from './PageTitle';
import {sendMessage} from '../../vuplex';
import _ from 'lodash';
import ButtonMinor from '../../components/ButtonMinor';
import {MdPlayArrow, MdStop} from 'react-icons/md';
import {useEnterKey} from '../../hooks/useEnterKey';
import InAppTooltip from './UnityReactComponents/InAppTooltip';
import {GiJetpack} from 'react-icons/gi';

const sendInitRequest = () => {
  sendMessage({
    Type: 'initRequest',
  });

  console.log('initRequest');
};

const percentage = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const VehicleHud = ({}) => {
  const [ammo, setAmmo] = useState(0);
  const [fuelRemaining, setFuelRemaining] = useState(0);
  const [velocity, setVelocity] = useState(0);

  const [raceState, setRaceState] = useState({});
  const [raceProps, setRaceProps] = useState({});
  const [stats, setStats] = useState({});


  const toast = useToast();

  useEffect(() => {
    document.body.style.background = 'none';
    sendInitRequest();
  }, []);

  useVuplex({
    jetpackState: ({
      AmmoRemaining,
      FuelRemaining,
      Velocity,
    }) => {

      console.log('jetpackState', AmmoRemaining, FuelRemaining, Velocity);

      setAmmo(AmmoRemaining);
      setFuelRemaining(FuelRemaining);
      setVelocity(Velocity);
    },

    jetpackMessage: ({Message, ShowForSeconds}) => {
      toast({
        title: Message,
        status: 'success',
        duration: (ShowForSeconds * 1000) || 2000,
      });
    },


    streakTrickStatsState: (props) => {
      console.log(props)
      setStats(props);
    },

    raceProps: (props) => {
      setRaceProps(props);
    },
    raceState: (state) => {
      setRaceState(state);
    },
  });


  return (
    <>
      <PageTitle title="VehicleHud - Wooorld"/>

      <Box
        h="100vh"
        w="100vw"
        borderRadius="40%"
        // border="groove 25px cyan"
        boxShadow="inset 0 0 50px 1px #0ff3"
        bg="#0000"
        overflow="hidden"
      >
        <Flex h="full" w="full" justify="center" gap={0}>

          <Stack h="full" w="full" justify="center" gap={0} justifyContent="flex-end" paddingBottom="10em">
            <Text
              textShadow="0 0 15px #faa"
              fontFamily="monospace"
              fontSize="2em"
              textAlign="left"
              color="#faaa"
            >
              {velocity.toFixed(2)}m/s
            </Text>
            <Text
              textShadow="0 0 15px #faa"
              fontFamily="monospace"
              fontSize="2em"
              textAlign="left"
              color="#faaa"
            >
              Fuel: {fuelRemaining.toFixed(2)}
            </Text>
          </Stack>

          <Stack h="full" w="full" justify="center" gap={0} justifyContent="flex-end">

            <Code
              bg="none"
              textShadow="0 0 15px #faa"
              fontFamily="monospace"
              fontSize="0.75em"
              textAlign="center"
              color="#faaa"
              marginBottom="20em"
            >
              {JSON.stringify(stats, null, 2)}
            </Code>

            <Text
              textShadow="0 0 15px #faa"
              fontFamily="monospace"
              fontSize="2em"
              textAlign="center"
              color="#faaa"
            >
              Lap: {raceState.Lap}/{raceProps.lapsTotal}
            </Text>
            <Text
              textShadow="0 0 15px #faa"
              fontFamily="monospace"
              fontSize="2em"
              textAlign="center"
              color="#faaa"
            >
              Chkpt: {raceState.Checkpoint}/{raceProps.checkpointsTotal}
            </Text>

            <Text
              textShadow="0 0 15px #faa"
              fontFamily="monospace"
              fontSize="2em"
              textAlign="center"
              color="#faaa"
            >
              {percentage.format(1 - raceState.Progress)} this lap
            </Text>
          </Stack>

          <Stack h="full" w="full" justify="center" gap={0} justifyContent="flex-end" paddingBottom="10em">
            <Text
              textShadow="0 0 15px #faa"
              fontFamily="monospace"
              fontSize="2em"
              textAlign="left"
              color="#faaa"
            >
              ammo: {ammo}
            </Text>
          </Stack>

        </Flex>

      </Box>

      {/*<Flex justify="space-between" textAlign="center" color="cyan" h="10%" w="full">*/}
      {/*  <Card bg="none">*/}
      {/*    <CardHeader>Stuntpeople returned</CardHeader>*/}
      {/*    <CardBody fontSize="2em" textAlign="center" color="cyan">{itemsDelivered}</CardBody>*/}
      {/*  </Card>*/}

      {/*  <Card bg="none">*/}
      {/*    <CardHeader>Fuel</CardHeader>*/}
      {/*    <CardBody>*/}
      {/*      <CircularProgress*/}
      {/*        value={fuelRemaining * 100}*/}
      {/*        // thickness="0.2em"*/}
      {/*        color={fuelRemaining > 0.5 ? 'green' : fuelRemaining > 0.25 ? 'gold' : 'red'}*/}
      {/*        trackColor="black24"*/}
      {/*      />*/}
      {/*    </CardBody>*/}
      {/*  </Card>*/}

      {/*  <Card bg="none">*/}
      {/*    <CardHeader>Velocity</CardHeader>*/}
      {/*    <CardBody>*/}
      {/*      <CircularProgress*/}
      {/*        value={velocity * 0.5}*/}
      {/*        // thickness="0.2em"*/}
      {/*        color={'cyan'}*/}
      {/*        trackColor="black24"*/}
      {/*      />*/}
      {/*      <AbsoluteCenter>*/}
      {/*        <Text>{Math.round(velocity)}m/s</Text>*/}
      {/*      </AbsoluteCenter>*/}

      {/*    </CardBody>*/}
      {/*  </Card>*/}

      {/*  <Card bg="none">*/}
      {/*    <CardHeader>Stuntpeople still missing</CardHeader>*/}
      {/*    <CardBody fontSize="2em" textAlign="center" color="gold">{itemsRemaining}</CardBody>*/}
      {/*  </Card>*/}


      {/*</Flex>*/}


      {/*<GiJetpack size="10em" />*/}
    </>
  );


};

export default VehicleHud;
